import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { OfferTypeLabel, RoomsLabel } from '../../../constants/demand';
import { IState } from '../../../store';
import { getOfferType, isCommercial } from '../../../utils/offer_type';
import { TrapNew } from '../components/TrapNew/TrapNew';
import { getPhoneText, getName } from '../utils';
import { demandCloseSuccessModalAction, demandShowSuccessModal } from '@cian/demand-trap-widget';
import { ICreateMessageForOfferRequest } from '../../../repositories/demand/v2/create-message-for-offer';
import { sendDemandRequest } from '../../../store/demand/demandThunk';
import { getFullAddressFromGeo } from '../utils/getFullAddressFromGeo';
import { isFakeEmail } from '../../../utils/validate';
import { trackInViewPort } from '../../../actions/requestDemand';
import { EDemandBlockTypes } from '../../../constants/requestDemand';

export const mapStateToProps = (state: IState) => {
  const {
    offerData: { offer, user },
  } = state;
  const { id, dealType, geo } = offer;
  const firstName = user && user.isAuthenticated ? user.firstName : '';
  const lastName = user && user.isAuthenticated ? user.lastName : '';
  const realtyCategory = isCommercial(getOfferType(offer)) ? 'commercial' : 'flat';
  const realtyType = OfferTypeLabel[getOfferType(offer)] || 'other';
  const roomCount =
    RoomsLabel[offer.roomsCount] || (offer.flatType && offer.flatType !== 'rooms' ? offer.flatType : '');

  return {
    isSuccessModalOpen: demandShowSuccessModal(state),
    name: getName(firstName || '', lastName || ''),
    phone: getPhoneText(user),
    email: user && user.isAuthenticated && user.email && !isFakeEmail(user.email) ? user.email : '',
    displayName: (user && user.isAuthenticated && user.companyName) || undefined,
    isAuthenticated: Boolean(user && user.isAuthenticated),
    offerId: id,
    dealType,
    isHomeowner: state.isHomeowner,
    address: getFullAddressFromGeo(geo.address),
    realtyType,
    realtyCategory,
    roomCount,
  };
};

export const actions = (dispatch: Dispatch<IState>) => ({
  demandCloseSuccessModalAction() {
    dispatch(demandCloseSuccessModalAction());
  },
  demandRequestCreateMessageStartAction(data: ICreateMessageForOfferRequest) {
    dispatch(sendDemandRequest(data));
  },
  onShownInViewPort(visible: boolean) {
    dispatch(trackInViewPort(EDemandBlockTypes.DEMAND, visible));
  },
});

// После переопределения Trap из функционального компонента в класс, ts решил, что offerId может быть undefined
// Нигде в проекте offerId не может быть undefined, такого тайпинга вообще нет, источник проблемы не нашли
// @ts-ignore
export const TrapNewContainer = connect(mapStateToProps, actions)(TrapNew);
